export function calculateLoanAmount(spa, loan_margin) {
	let loan_amount = spa * (loan_margin / 100)
	return parseFloat2Decimal(loan_amount)
}

export function calculateInstallment(loan_amt, interest_rate, tenure_year) {
	if (interest_rate == 0 || interest_rate == '') {
		let m = loan_amt / (tenure_year * 12)
		return parseFloat2Decimal(m)
	} else {
		let p = parseFloat(loan_amt);
		let r = (parseFloat(interest_rate) !== 0) ? (parseFloat(interest_rate) / 100 / 12) : 0;
		let n = parseFloat(tenure_year) * 12;
		let m = 0;
		if ((Math.pow(1 + r, n) - 1) > 0) {
			m = p * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
		}
		return parseFloat2Decimal(m)
	}
}

export function calculatePersonalLoanInstallment(loan_amt, interest_rate, tenure_year) {
	if (interest_rate == 0 || interest_rate == '') {
		let m = loan_amt / (tenure_year * 12)
		return parseFloat2Decimal(m)
	} else {
		let p = parseFloat(loan_amt);
		let r = (parseFloat(interest_rate) !== 0) ? (parseFloat(interest_rate) / 100) : 0;
		let n = parseFloat(tenure_year) * 12;
		let l = (p * r * parseFloat(tenure_year)) + p
		let m = l / n
		return parseFloat2Decimal(m)
	}
}

export function calculateClientNett(spa_price, cb_percent_to_customer) {
	let client_nett = spa_price * ((100 - cb_percent_to_customer) / 100);
	return parseFloat2Decimal(client_nett)
}

export function calculateBuyerDiscount(client_nett, spa_price) {
	let buyer_discount = 100 - ((client_nett / spa_price) * 100);
	return parseFloat2Decimal(buyer_discount)
}

export function calculateCashback(loan_amount, client_nett) {
	let cashback = loan_amount - client_nett
	return parseFloat2Decimal(cashback)
}

export function calculateLoanMargin(spa_price, loan_amount) {
	let margin = spa_price / loan_amount * 100
	return parseFloat2Decimal(margin)
}

function parseFloat2Decimal(amount) {
	return parseFloat(amount).toFixed(2);
}
function calculateMax(value, interest, months) {
	// Compute the result of the formula
	const result = Math.floor((value * months) / interest / 1000) * 1000;
	// Return the maximum of the result and 0
	return Math.max(result, 0);
}
export function calculateLoanEligibility(data, loanType) {
	// Initialize result with data
	let result = { ...data };
	// Default DSR ratio
	result.dsr_ratio = 70 / 100; // Default DSR 70%

	// Update DSR ratio if moratorium eligible
	let moratorium_rate = 0;
	if (data.moratorium_eligible === true) {
		result.dsr_ratio = 150 / 100; // Moratorium DSR 150%
		moratorium_rate = (data.moratorium_eligible_rate / 100);
	}

	// Calculate eligible amount based on DSR ratio
	result.dsr_eligible = (parseFloat(data.net_income) * result.dsr_ratio).toFixed(2);
	// console.log(data);

	// Calculate installment eligible and available
	result.installment_eligible = (parseFloat(data.net_income) - parseFloat(data.net_dispose_income)).toFixed(2);
	result.installment_available = result.installment_eligible - parseFloat(data.final_installment);
	// console.log(`final_installment: ${data.final_installment}, installment_available: ${result.installment_available}`);
	// console.log(`installment_eligible: ${result.installment_eligible}, installment_available: ${result.installment_available}`);

	// Initialize loan eligibility array
	result.loan_eligible = [];

	const backend_calc = result.installment_available * (1+moratorium_rate);
	let baseInterestRate = loanType.interest_rate;
	if(!_gHlp.isEmpty(data.interest_rate) && (parseFloat(data.interest_rate) > 0)){
		baseInterestRate = parseFloat(data.interest_rate)
	}
	let interestRate = 1 + (parseFloat(baseInterestRate) / 100)

	// Determine loan eligibility based on loan type
	if (loanType.code === 'STL' || loanType.code === 'FEL') {
		const months = [3, 6, 9];
		for (let i = 0; i < months.length; i++) {
			result.loan_eligible[i] = {
				period_number: months[i],
				period: `${months[i]} Months`,
				tenure_period: `Months`,
				loan_type_id: loanType.id
			};

			if (result.installment_available < 0) {
				result.loan_eligible[i].eligible_amount = 0;
			} else {
				const loanEligible = calculateMax(backend_calc, interestRate, months[i]);
				result.loan_eligible[i].eligible_amount = loanEligible;
			}


			const debt_amount = (parseFloat(data.ccris_settlement) + parseFloat(data.non_ccris_settlement) + parseFloat(data.other_payment_settlement));
			result.loan_eligible[i].after_debt_conso = result.loan_eligible[i].eligible_amount - debt_amount;
			result.loan_eligible[i].status = result.loan_eligible[i].after_debt_conso > 0 ? 'PASS' : 'FAIL';
		}
	} else {
		const years = 10;
		
		for (let i = 0; i < years; i++) {
			result.loan_eligible[i] = {
				period_number: i + 1,
				period: `${i + 1} Years`,
				tenure_period: `Years`,
				loan_type_id: loanType.id
			};

			if (result.installment_available < 0) {
				result.loan_eligible[i].eligible_amount = 0;
			} else {
				let perYearRate = baseInterestRate;
				if ((loanType.code === 'AK') && (isNaN(perYearRate) || parseFloat(perYearRate) === 0)) {
					perYearRate = ((i + 1) >= 6) ? 12 : 18;
				}
				let interestRate = 1 + (parseFloat(perYearRate * (i + 1)) / 100)
				const loanEligible = calculateMax(backend_calc, interestRate, (12 * result.loan_eligible[i].period_number));
				// console.log(`loanEligible: ${loanEligible}`);
				result.loan_eligible[i].eligible_amount = loanEligible;
				// result.loan_eligible[i].eligible_amount = Math.round(
				// 	(backend_calc * 12 * result.loan_eligible[i].period_number) /
				// 	(loanType.interest_rate / 100 * result.loan_eligible[i].period_number + 1)
				// );
			}

			const debt_amount = (parseFloat(data.ccris_settlement) + parseFloat(data.non_ccris_settlement) + parseFloat(data.other_payment_settlement));
			result.loan_eligible[i].after_debt_conso = result.loan_eligible[i].eligible_amount - debt_amount;
			result.loan_eligible[i].status = result.loan_eligible[i].after_debt_conso > 0 ? 'PASS' : 'FAIL';
		}
	}

	return result;
}
export function calculateInvinitySettlement(request) {
	// Extract input values from request object (assuming it's similar to PHP's $request)
	const debt_amount = parseFloat(_gHlp.getValue(request, 'debt_amount', 100000));
	const tenure_year = parseInt(_gHlp.getValue(request, 'tenure_year', 1));
	const interest_rate = parseFloat(_gHlp.getValue(request, 'interest_rate', 1.40)) / 100;
	const adv_insurance = parseFloat(_gHlp.getValue(request, 'adv_insurance', 0))
	const stamp_duty_rate = parseFloat(_gHlp.getValue(request, 'stamp_duty_rate', 0.5)) / 100;
	const vf_service_rate = parseFloat(_gHlp.getValue(request, 'vf_service_rate', 0)) / 100;
	const sst_rate = 1 + parseFloat(_gHlp.getValue(request, 'sst_rate', 8)) / 100;
	const legal_fees_amount = parseFloat(_gHlp.getValue(request, 'legal_fees_amount', 1500));
	const stakeholder_mth = parseInt(_gHlp.getValue(request, 'stakeholder_mth', (tenure_year <= 2) ? 1 : ((tenure_year <= 4) ? 2 : ((tenure_year <= 6) ? 3 : 4))));
	const monthly_value = parseInt(tenure_year) * 12;
	const is_manual = _gHlp.getValue(request, 'is_manual', false);
	const manual_loan = _gHlp.getValue(request, 'manual_loan', 0);
	const manual_stamp_duty = _gHlp.getValue(request, 'manual_stamp_duty', 0);
	const manual_vet_fac_amt = _gHlp.getValue(request, 'manual_vet_fac_amt', 0);
	const manual_stakeholder_sum = _gHlp.getValue(request, 'manual_stakeholder_sum', 0);
	const manual_legal_fees = _gHlp.getValue(request, 'manual_legal_fees', 0);
	const interval = 1000;

	// Initialize variables
	let loopqty = 1;
	let loop = true;
	let loan_amount = parseFloat(is_manual ? manual_loan : 0);
	let installment, stamp_duty, vf_service_fees, legal_fee, disbursement_to_client, stakeholder_sum;
	let first_check = null;
	let final_result; 

	while (loop) {

		vf_service_fees = (manual_vet_fac_amt > 0) ? manual_vet_fac_amt : ((loan_amount * vf_service_rate) * sst_rate);
		stamp_duty = (manual_stamp_duty > 0) ? manual_stamp_duty : (loan_amount * stamp_duty_rate);
		legal_fee = (manual_legal_fees > 0) ? manual_legal_fees : (legal_fees_amount * sst_rate);
		installment = ((loan_amount * interest_rate * tenure_year) + loan_amount) / monthly_value;
		stakeholder_sum = (manual_stakeholder_sum > 0) ? manual_stakeholder_sum : ((adv_insurance > 0) ? parseFloat(adv_insurance) : (installment * stakeholder_mth));
		
		disbursement_to_client = loan_amount - vf_service_fees - stamp_duty - legal_fee - stakeholder_sum - debt_amount;

		if (disbursement_to_client > debt_amount) {
			if (first_check == 'SMALLER') {
				loop = false;
				break;
			}
			first_check = 'BIGGER';
		} else {
			if (first_check == 'BIGGER') {
				loop = false;
				break;
			}
			first_check = 'SMALLER';
		}

		final_result = {
			debt_amount: debt_amount,
			tenure: tenure_year,
			loan_amount: loan_amount.toFixed(2),
			installment: installment.toFixed(2),
			stamp_duty: stamp_duty.toFixed(2),
			legal_fees: legal_fee.toFixed(2),
			stakeholder_sum: stakeholder_sum.toFixed(2),
			stakeholder_mth: stakeholder_mth,
			vf_service_fees: vf_service_fees.toFixed(2),
			disbursement_to_client: disbursement_to_client.toFixed(2),
			err_message: null
		};

		if(is_manual){
			loop = false;
			break;
		}

		loan_amount = (first_check == 'SMALLER') ? (loan_amount + interval) : (loan_amount - interval);

		loopqty++;
		if (loopqty > 10000) {
			final_result = {
				debt_amount: debt_amount,
				tenure: tenure_year,
				loan_amount: 0,
				installment: 0,
				stamp_duty: 0,
				legal_fees: 0,
				stakeholder_sum: 0,
				stakeholder_mth: 0,
				vf_service_fees: 0,
				disbursement_to_client: 0,
				err_message: 'INVINITY LOOP'
			}
			break;
		}

	}
	// Return result similar to PHP's [200, $return]
	return final_result;
}
export function calculateFees(data, tenure_year, debt_amount, loanType, interest_rate=null, loan_amount = null, is_manual=false){
	if(_gHlp.isEmpty(interest_rate)){
		interest_rate = parseFloat(_gHlp.getValue(loanType, 'interest_rate', interest_rate))
	}
	const stakeholderRanges = _gHlp.getValue(loanType, 'stakeholder_range', []);
	const stakeholderRange = stakeholderRanges.find(itm => itm.years == tenure_year);

	const req = {
		debt_amount:debt_amount,
		tenure_year:tenure_year,
		interest_rate:interest_rate,
		stamp_duty_rate: parseFloat(_gHlp.getValue(loanType, 'stamp_duty_rate', 0.5)),
		vf_service_rate: parseFloat(_gHlp.getValue(loanType, 'vet_fac_rate', 0)),
		sst_rate: parseFloat(_gHlp.getValue(loanType, 'sst_rate', 8)),
		legal_fees_amount: parseFloat(_gHlp.getValue(loanType, 'legal_fees', 8)),
		stakeholder_mth: parseInt(_gHlp.getValue(stakeholderRange, 'months', 0)),

		is_manual: is_manual,
		manual_loan:loan_amount,
		manual_stamp_duty: parseFloat(_gHlp.getValue(data, 'stamp_duty', 0)),
		manual_vet_fac_amt: parseFloat(_gHlp.getValue(data, 'vet_fac_amt', 0)),
		manual_stakeholder_sum: parseFloat(_gHlp.getValue(data, 'stakeholder_sum', 0)),
		manual_legal_fees: parseFloat(_gHlp.getValue(data, 'legal_fees', 0)),
	}
	
	return calculateInvinitySettlement(req)
}
export function calculateRule78(data, loanType) {
	let result = { ...data };
	let loanTenureInMonths = parseInt(data.loan_tenure) * 12;
	let interestRate = parseFloat(loanType.interest_rate);

	if (!_gHlp.isEmpty(data.interest_rate)) {
		interestRate = parseFloat(data.interest_rate);
	}

	result.total_interest = parseFloat(data.loan_amount) * interestRate / 100 * parseInt(data.loan_tenure);
	result.total_amount_paid = parseFloat(data.loan_amount) + result.total_interest;
	result.installment = (loanTenureInMonths > 0) ? result.total_amount_paid / loanTenureInMonths : 0;

	// const rules78 = (loanTenureInMonths / 2) * (loanTenureInMonths + 1);
	const rules78 = (loanTenureInMonths * (loanTenureInMonths + 1)) / 2;

	if (!_gHlp.isEmpty(data.moratorium_tenure) && !_gHlp.isEmpty(data.moratorium_eligible_rate) && (parseFloat(data.moratorium_tenure) > 0)) {
		result.moratorium_installment = (result.installment * (parseFloat(data.moratorium_eligible_rate) / 100)).toFixed(2);
	}

	let loanTable = [];
	let moratoriumInstallmentAmount = 0;
	let column = loanTenureInMonths;
	let period = 1;
	let balance = parseFloat(data.loan_amount).toFixed(2);
	for (let i = 0; i < loanTenureInMonths; i++) {
		let installment;
		let principal;

		if (data.moratorium_tenure !== undefined &&
			result.moratorium_installment !== undefined &&
			data.moratorium_start_period !== undefined &&
			data.moratorium_tenure > 0 &&
			period >= data.moratorium_start_period &&
			period < (data.moratorium_start_period + data.moratorium_tenure)) {

			installment = parseFloat(result.moratorium_installment).toFixed(2);
			moratoriumInstallmentAmount += parseFloat(result.moratorium_installment).toFixed(2);
		} else {
			installment = parseFloat(result.installment).toFixed(2);
		}
		
		let interest_charged = (parseFloat(result.total_interest).toFixed(2) / rules78) * column;
		if(loanTenureInMonths == period){
			installment = balance + interest_charged;
			principal = balance;
		}else{
			principal = parseFloat(installment).toFixed(4) - parseFloat(interest_charged).toFixed(4);
		}
		balance = balance - principal;

		loanTable.push({
			period,
			column,
			installment,
			interest_charged,
			principal,
			balance
		});

		period++;
		column--;
	}
	
	result.interest_rate = interestRate,
	result.loan_table = loanTable;

	return result;
}
export function calculateFactoryLoan(data, loanType) {
	// Initialize result with data
	let result = { ...data };

	// Calculate loan tenure in months
	const loanTenureInMonths = parseInt(data.loan_tenure) * 12;;
	let interestRate = parseFloat(loanType.interest_rate);

	// Check if a custom interest rate is provided
	if (!_gHlp.isEmpty(data.interest_rate)) {
		interestRate = parseFloat(data.interest_rate);
	}

	// Calculate total interest, total amount paid, and installment
	result.total_interest = parseFloat(data.loan_amount) * interestRate / 100;
	result.total_amount_paid = parseFloat(data.loan_amount) + result.total_interest;
	result.installment = result.total_amount_paid / loanTenureInMonths;

	// Calculate rules78 value
	// const rules78 = (loanTenureInMonths / 2) * (loanTenureInMonths + 1);

	let moratoriumInstallmentAmount = 0;

	// Check if moratorium details are provided
	if (data.moratorium_tenure !== undefined &&
		data.moratorium_eligible_rate !== undefined &&
		parseFloat(data.moratorium_tenure) > 0) {
		result.moratorium_installment = (result.total_interest / loanTenureInMonths) * (parseFloat(data.moratorium_eligible_rate) / 100);
	}

	// Initialize loan table
	let loanTable = [];

	// Iterate over each month of the loan
	for (let i = 0; i < loanTenureInMonths; i++) {
		const period = i + 1;
		const column = loanTenureInMonths - i;

		// Calculate interest charged
		const interestCharged = result.total_interest / loanTenureInMonths;

		let installment;

		if (period === loanTenureInMonths) {
			// Last period adjustment
			installment = data.loan_amount + result.installment + moratoriumInstallmentAmount;
		} else if (data.moratorium_tenure !== undefined &&
			result.moratorium_installment !== undefined &&
			data.moratorium_start_period !== undefined &&
			data.moratorium_tenure > 0 &&
			period >= data.moratorium_start_period &&
			period < (data.moratorium_start_period + data.moratorium_tenure)) {
			// During moratorium period
			installment = interestCharged - result.moratorium_installment;
			moratoriumInstallmentAmount += result.moratorium_installment;
		} else {
			// Regular period
			installment = interestCharged;
		}

		// Principal is always 0 in this method
		const principal = 0;

		// Calculate balance
		let balance;
		if (i === 0) {
			balance = data.loan_amount - principal;
		} else {
			balance = loanTable[i - 1].balance - principal;
		}

		if (balance < 0) {
			balance = 0;
		}

		// Push loan details for the current period into the loanTable
		loanTable.push({
			period,
			column,
			interest_charged: interestCharged,
			installment,
			principal,
			balance
		});
	}

	// Attach loan table to result
	result.interest_rate = interestRate,
		result.loan_table = loanTable;
	return result;
}
export function calculateShortTermLoan(data, loanType) {
	// Initialize result with data
	let result = { ...data };

	// Calculate loan tenure in months
	const loanTenureInMonths = parseInt(data.loan_tenure);
	let interestRate = parseFloat(loanType.interest_rate);

	// Check if a custom interest rate is provided
	if (!_gHlp.isEmpty(data.interest_rate)) {
		interestRate = parseFloat(data.interest_rate);
	}

	// Calculate total interest, total amount paid, and installment
	result.total_interest = parseFloat(data.loan_amount) * interestRate / 100;
	result.total_amount_paid = parseFloat(data.loan_amount) + result.total_interest;
	result.installment = 0;

	// Determine the paid period
	result.paid_period = loanTenureInMonths;
	if (data.paid_period !== undefined) {
		result.paid_period = data.paid_period;
	}

	// Initialize loan table
	let loanTable = [];

	// Iterate over each month of the loan
	for (let i = 0; i < loanTenureInMonths; i++) {
		const period = i + 1;
		const column = loanTenureInMonths - i;

		let installment = 0;
		let interestCharged = 0;
		let principal = 0;
		let balance;

		if (period === result.paid_period) {
			installment = result.total_amount_paid;
			interestCharged = result.total_interest;
			principal = data.loan_amount;
			balance = 0;
		} else {
			balance = data.loan_amount;
		}

		// Push loan details for the current period into the loanTable
		loanTable.push({
			period,
			column,
			installment,
			interest_charged: interestCharged,
			principal,
			balance
		});
	}

	// Attach loan table to result
	result.interest_rate = interestRate,
		result.loan_table = loanTable;
	return result;
}
export function calculateFlexiLoan(data, loanType) {
	// Initialize result with data
	let result = { ...data };

	// Loan tenure in months
	const loanTenureInMonths = data.loan_tenure;

	// Set interest rate
	let interestRate = loanType.interest_rate;
	if (data.interest_rate !== undefined) {
		interestRate = data.interest_rate;
	}

	// Calculate total interest, total amount paid, and installment
	result.total_interest = data.loan_amount * interestRate / 100;
	result.total_amount_paid = data.loan_amount + result.total_interest;
	result.installment = 0;

	// Determine the paid period
	result.paid_period = loanTenureInMonths;
	if (data.paid_period !== undefined) {
		result.paid_period = data.paid_period;
	}

	// Initialize loan table
	let loanTable = [];

	// Iterate over each month of the loan
	for (let i = 0; i < loanTenureInMonths; i++) {
		const period = i + 1;
		const column = loanTenureInMonths - i;

		let installment = 0;
		let interestCharged = 0;
		let principal = 0;
		let balance;

		if (period === result.paid_period) {
			installment = result.total_amount_paid;
			interestCharged = result.total_interest;
			principal = data.loan_amount;
			balance = 0;
		} else {
			balance = data.loan_amount;
		}

		// Add details for the current period to the loan table
		loanTable.push({
			period,
			column,
			installment,
			interest_charged: interestCharged,
			principal,
			balance
		});
	}

	// Attach loan table to result
	result.interest_rate = interestRate;
	result.loan_table = loanTable;
	return result;
}
export function calculateAngkasaLoan(data, loanType) {
    let result = { ...data };
    const loanTenureYears = parseInt(data.loan_tenure);
    const loanTenureInMonths = loanTenureYears * 12;
    let interestRate = parseFloat(_gHlp.getValue(loanType, 'interest_rate', 0));
    if (!_gHlp.isEmpty(data.interest_rate)) {
        interestRate = parseFloat(data.interest_rate);
    } else if (interestRate === 0 || isNaN(interestRate)) {
        interestRate = (loanTenureYears >= 6) ? 12 : 18;
    }

    result.total_interest = parseFloat(data.loan_amount) * (interestRate / 100) * loanTenureYears;
    result.total_amount_paid = parseFloat(data.loan_amount) + result.total_interest;
    const monthlyInstallment = (loanTenureInMonths > 0) ? (result.total_amount_paid / loanTenureInMonths) : 0;
    result.installment = monthlyInstallment;

    let loanTable = [];
    const rules78 = (loanTenureInMonths * (loanTenureInMonths + 1)) / 2;
    let balance = parseFloat(data.loan_amount);
    for (let i = 0; i < loanTenureInMonths; i++) {
        const period = i + 1;
        const column = loanTenureInMonths - i;
        let installment = monthlyInstallment;
        const interestCharged = (result.total_interest / rules78) * column;
        let principal = installment - interestCharged;
        if (period === loanTenureInMonths) {
            principal = balance;
            installment = principal + interestCharged;
        }
        balance = balance - principal;
        loanTable.push({ period, column, installment, interest_charged: interestCharged, principal, balance });
    }

    result.interest_rate = interestRate;
    result.loan_table = loanTable;
    return result;
}
